import { useTheme } from 'styled-components'

import { useIsMobile } from 'utils/useIsMobile'
import { getFormattedTickValue, isDateTickLabel } from './utils'

interface TickProps {
  x: number
  y: number
  isSingleDayRange: boolean
  index: number
  payload: {
    value: number
  }
}

export const CustomTick = ({ x, y, payload, isSingleDayRange, index }: TickProps) => {
  const { value } = payload

  const isMobile = useIsMobile()
  const theme = useTheme()

  const label = getFormattedTickValue(value, index === 0, isSingleDayRange)

  return (
    <text
      x={x}
      y={y + 15}
      textAnchor="middle"
      fontSize={isMobile ? 12 : 14}
      fontWeight={isDateTickLabel(label) ? 700 : 400}
      fill={theme.colors.text.primary}
    >
      {label}
    </text>
  )
}
